"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundPage = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
require("./NotFoundPage.scss");
var SupportEmailLink_1 = require("@app/components/SupportEmailLink");
var YellowButton_1 = require("@app/components/controls/YellowButton");
var Page_1 = require("@app/components/layout/Page");
var initialState = {
    q1Visible: false,
    q2Visible: false,
    q3Visible: false
};
var goBack = function (prevPath, history) {
    // Previous function that utilized History's goBack feature
    /*
    if (prevPath.includes('received')) {
      history.push('/dash');
    } else {
      history.goBack();
    }
    */
    history.push('/dash');
};
/**
 * Catch all page for handling 404
 */
var NotFoundPage = /** @class */ (function (_super) {
    __extends(NotFoundPage, _super);
    function NotFoundPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = initialState;
        _this.displayQ1 = function () {
            _this.setState(__assign(__assign({}, _this.state), { q1Visible: !_this.state.q1Visible }));
        };
        _this.displayQ2 = function () {
            _this.setState(__assign(__assign({}, _this.state), { q2Visible: !_this.state.q2Visible }));
        };
        _this.displayQ3 = function () {
            _this.setState(__assign(__assign({}, _this.state), { q3Visible: !_this.state.q3Visible }));
        };
        return _this;
    }
    NotFoundPage.prototype.render = function () {
        var _this = this;
        var q1Content = react_1.default.createElement("h2", { className: classnames_1.default('subtitle', 'has-blast-yellow-text', { hidden: !this.state.q1Visible }) },
            "Please note that forwarding a Blast email does ",
            react_1.default.createElement("strong", { className: "has-blast-gray-text" }, "not"),
            " forward the package itself. Please reach out to your business partner to forward the package directly through Blast.");
        var q2Content = react_1.default.createElement("h2", { className: classnames_1.default('subtitle', 'has-blast-yellow-text', { hidden: !this.state.q2Visible }) }, "Please ensure you are logged in to the account that received the Blast email notification.");
        var q3Content = react_1.default.createElement("h2", { className: classnames_1.default('subtitle', 'has-blast-yellow-text', { hidden: !this.state.q3Visible }) }, "Your package is likely too old to recover.");
        var nfpState = this.props.location.state; // Not Found Page location state
        return (react_1.default.createElement(Page_1.Page, { title: "Not Found" },
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: "column is-half is-offset-one-quarter not-found-view" },
                    react_1.default.createElement("h1", { className: "title" }, "Content Not Available"),
                    react_1.default.createElement("h2", { className: "subtitle" },
                        "Did someone forward you a Blast email? If yes, ",
                        react_1.default.createElement("a", { onClick: this.displayQ1 }, "click here"),
                        "."),
                    q1Content,
                    react_1.default.createElement("h2", { className: "subtitle" },
                        "Do you have more than one Blast account? If yes, ",
                        react_1.default.createElement("a", { onClick: this.displayQ2 }, "click here"),
                        "."),
                    q2Content,
                    react_1.default.createElement("h2", { className: "subtitle" },
                        "If neither of these scenarios apply to you, ",
                        react_1.default.createElement("a", { onClick: this.displayQ3 }, "click here"),
                        "."),
                    q3Content,
                    react_1.default.createElement("hr", { className: "divider" }),
                    react_1.default.createElement("h2", { className: "subtitle" },
                        "If you still have questions about this package, please reach out to us at ",
                        react_1.default.createElement(SupportEmailLink_1.SupportEmailLink, null),
                        "."),
                    react_1.default.createElement("h2", { className: "subtitle" }, "Over and out."),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-large", "data-test": "back-button", onClick: function () { return goBack((nfpState ? nfpState.prevPath : ''), _this.props.history); } },
                            react_1.default.createElement("span", { className: "icon" },
                                react_1.default.createElement("i", { className: "fas fa-chevron-left" })),
                            react_1.default.createElement("span", null, "Go to your inbox")))))));
    };
    return NotFoundPage;
}(react_1.Component));
exports.NotFoundPage = NotFoundPage;
